import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../../../commons/routes/routes';
import { selectors as userSelectors } from '../../../../redux/modules/usuario';
import { connect } from 'react-redux';
import { compose } from 'redux';
import DynamicIframe from '../../../AppLayout/containers/DynamicIframe';

const STORAGE_KEY = 'dynamicRedirectUrl';

class OAuth2DynamicRedirectHandler extends PureComponent {

    constructor(props) {
        super(props);
        // Se vier URL_DYNAMIC na query string, persiste no localStorage
        const urlDynamic = this.getUrlParameter('URL_DYNAMIC');
        if (urlDynamic) {
            localStorage.setItem(STORAGE_KEY, urlDynamic);
        }
        this.iframeUrl = null;
    }

    getUrlParameter(name) {
        // eslint-disable-next-line
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(this.props.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    buildIframeUrl(url, accessToken) {
        if (!accessToken) return url;
        const separator = url.includes('?') ? '&' : '/?';
        return `${url}${separator}access_token=${accessToken}`;
    }

    render() {
        const { isAuthenticated, accessToken } = this.props;

        // Usuário não autenticado: salva no localStorage e redireciona para login
        if (!isAuthenticated) {
            return <Redirect to={ROUTES.LOGIN.path} />;
        }

        // Usuário autenticado: lê a URL do localStorage (apenas na primeira vez)
        if (!this.iframeUrl) {
            const storedUrl = localStorage.getItem(STORAGE_KEY);
            if (storedUrl) {
                localStorage.removeItem(STORAGE_KEY);
                this.iframeUrl = this.buildIframeUrl(storedUrl, accessToken);
            }
        }

        if (this.iframeUrl) {
            return <DynamicIframe url={this.iframeUrl} title="Conteúdo Dinâmico" />;
        }

        // Nenhuma URL encontrada, vai para a tela inicial
        return <Redirect to={ROUTES.SERVICOS_DISPONIVEIS.path} />;
    }
}

const mapStateToProps = state => ({
    isAuthenticated: userSelectors.isAuthenticated(state),
    accessToken: userSelectors.getAccessToken(state),
});

export default compose(connect(mapStateToProps))(OAuth2DynamicRedirectHandler);
